(function () {
  const DRAWER = '[data-w1gk-menu-drawer]';
  const OPEN_BTN = '[data-w1gk-menu-open]';
  const CLOSE_EL = '[data-w1gk-menu-close]';
  const PANEL = '[data-w1gk-menu-panel]';
  const PANEL_ID = 'w1gk-menu-drawer-panel';

  function drawerEl() {
    return document.querySelector(DRAWER);
  }

  function ensureOnBody(drawer) {
    if (drawer && drawer.parentElement !== document.body) {
      document.body.appendChild(drawer);
    }
  }

  function setExpanded(open) {
    document.querySelectorAll(OPEN_BTN).forEach((btn) => {
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  function open(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    const drawer = drawerEl();
    if (!drawer) return false;

    ensureOnBody(drawer);

    // Nie zmieniaj data-menu-style — Fabric wtedy psuje grid (search do leftB).
    // Nasz drawer jest niezależny od native header drawer.

    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('w1gk-menu-open');
    setExpanded(true);

    if (location.hash !== '#' + PANEL_ID) {
      try {
        history.pushState(null, '', '#' + PANEL_ID);
      } catch (err) {
        location.hash = PANEL_ID;
      }
    }

    const panel = drawer.querySelector(PANEL);
    const closeBtn = panel && panel.querySelector('.w1gk-menu-drawer__close');
    if (closeBtn && typeof closeBtn.focus === 'function') {
      try {
        closeBtn.focus({ preventScroll: true });
      } catch (err) {
        closeBtn.focus();
      }
    }

    return true;
  }

  function close(e) {
    if (e) {
      const t = e.target;
      const closeEl = t && typeof t.closest === 'function' ? t.closest(CLOSE_EL) : null;
      const href = closeEl && closeEl.getAttribute ? closeEl.getAttribute('href') : '';
      // Hash overlay / X — blokuj skok. Prawdziwy URL (Sklep itd.) — pozwól nawigować.
      const isInPageClose = !href || href.charAt(0) === '#';
      if (isInPageClose) e.preventDefault();
    }

    const drawer = drawerEl();
    if (!drawer) return false;

    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('w1gk-menu-open');
    setExpanded(false);

    if (location.hash === '#' + PANEL_ID || location.hash === '#w1gk-menu-drawer-close') {
      try {
        history.replaceState(null, '', location.pathname + location.search);
      } catch (err) {
        location.hash = '';
      }
    }

    return true;
  }

  function toggle(e) {
    const drawer = drawerEl();
    if (drawer && drawer.classList.contains('is-open')) return close(e);
    return open(e);
  }

  window.W1GKMenu = { open, close, toggle };

  document.addEventListener(
    'click',
    (e) => {
      const t = e.target;
      if (!t || typeof t.closest !== 'function') return;

      if (t.closest(OPEN_BTN)) {
        open(e);
        return;
      }

      if (t.closest(CLOSE_EL)) {
        close(e);
      }
    },
    true
  );

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') close();
  });

  window.addEventListener('hashchange', () => {
    if (location.hash === '#' + PANEL_ID) open();
    else if (location.hash === '#w1gk-menu-drawer-close' || location.hash === '') close();
  });

  // popstate (pushState open/close bez hashchange)
  window.addEventListener('popstate', () => {
    if (location.hash === '#' + PANEL_ID) open();
    else close();
  });

  function bindAccordion() {
    const drawer = drawerEl();
    if (!drawer || drawer.dataset.w1gkAccordion === '1') return;
    const panel = drawer.querySelector(PANEL);
    if (!panel) return;
    drawer.dataset.w1gkAccordion = '1';

    panel.querySelectorAll('.w1gk-menu-drawer__details').forEach((details) => {
      details.addEventListener('toggle', () => {
        if (!details.open) return;
        panel.querySelectorAll('.w1gk-menu-drawer__details').forEach((other) => {
          if (other !== details && other.open) other.open = false;
        });
      });
    });
  }

  function boot() {
    document.querySelectorAll(DRAWER).forEach((el, i) => {
      if (i > 0) el.remove();
    });

    const drawer = drawerEl();
    if (drawer) {
      ensureOnBody(drawer);
      bindAccordion();
      if (location.hash === '#' + PANEL_ID) open();
      return;
    }

    let tries = 0;
    const t = window.setInterval(() => {
      tries += 1;
      const d = drawerEl();
      if (d) {
        ensureOnBody(d);
        bindAccordion();
        window.clearInterval(t);
        if (location.hash === '#' + PANEL_ID) open();
      } else if (tries > 50) {
        window.clearInterval(t);
      }
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
